import React from 'react'
import { Box, Text, Heading, Center, VStack, Input, HStack, Button, Image} from '@chakra-ui/react'
import { PasswordInput } from '../../../components/ui/password-input'
import { Field } from '../../../components/ui/field';
import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { InputGroup } from '../../../components/ui/input-group'
import { Toaster, toaster } from "../../../components/ui/toaster"
import logo from '../../../shared/assets/logo.png'
import { MdOutlineMail } from "react-icons/md"
import { MdOutlineLock } from 'react-icons/md'
import { FaRegUser } from "react-icons/fa"
import './createAccountCss.css'

const CreateAccount = () => {
    const [fullName, setFullName] = useState("")
    const [userName, setUserName] = useState("");
    const [email, setEmail] = useState("");
    const [dob, setDob] = useState("");
    const [password, setPassword] = useState("");
    const [passwordVerify, setPasswordVerify] = useState("");
    const [fullNameError, setFullNameError] = useState("");
    const [userNameError, setUserNameError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [dobError, setDobError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [passwordVerifyError, setPasswordVerifyError] = useState("");
    const [message, setMessage] = useState("");
    const [emailSent, setEmailSent] = useState(false);
    const [emailVerified, setEmailVerified] = useState(false);
    const navigate = useNavigate();

    const navToDashboard = () =>{
        navigate("/Dashboard/Landing");
        navigate(0)
    }

    const navToLogin = () =>{
        navigate("/Login")
    }


    // verify session
    useEffect(() => {
        const sessionToken = localStorage.getItem('sessionToken');
        if (sessionToken) {
          const url = new URL('/api/auth/sessionVerify', window.location.origin);
          fetch(url, {
            method: 'GET',
            headers: { 
                'Accept': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
          })
          .then(response => response.json())
          .then(data => {
            if (data.expired) {
              console.log("Session expired, please log in again.");
            } else {
              navToDashboard();
            }
          })
          .catch(error => {
            console.error("Error verifying session:", error);
          });
        }
    }, []);

    const [checkFullName, checkFullNameToggle] = useState(true);
    const [checkUsername, checkUsernameToggle] = useState(true);
    const [checkEmail, checkEmailToggle] = useState(true);
    const [checkDob, checkDobToggle] = useState(true);
    const [checkPassword, checkPasswordToggle] = useState(true);
    const [checkPasswordVerify, checkPasswordVerifyToggle] = useState(true);
    const [fullNameValid, setFullNameValid] = useState(false);
    const [userNameValid, setUserNameValid] = useState(false);
    const [emailValid, setEmailValid] = useState(false);
    const [dobValid, setDobValid] = useState(false);
    const [passwordValid, setPasswordValid] = useState(false);
    const [passwordVerifyValid, setPasswordVerifyValid] = useState(false);

    const initialRender = useRef({fullNameReady: false, userNameReady: false, emailReady: false, dobReady: false, passwordReady: false, passwordVerifyReady: false});
    const [trigger, setTrigger] = useState(false);


    // checking if fullname exiists
    const fullNameRegex = /^([A-Za-z])+\.? [a-zA-Z]+$/
    useEffect(() => {
        setFullNameError("");
        if(initialRender.current["fullNameReady"]){
            if(fullName === ""){
                setFullNameError("Please enter your full name");
                checkFullNameToggle(false);
                setFullNameValid(false);
            }
            else if(!fullNameRegex.test(fullName)){
                setFullNameError("Make sure name is less than 64 characters and only contains letters")
                checkFullNameToggle(false);
                setFullNameValid(false);
            }
            else{
                checkFullNameToggle(true);
                setFullNameValid(true);
            }
        }
        initialRender.current["fullNameReady"] = true;
    },[fullName, trigger])

    // checking if username exits
    useEffect(() => {
        setUserNameError("");
        if(initialRender.current["userNameReady"]){
            if(userName === ""){
                setUserNameError("Please enter a username");
                checkUsernameToggle(false);
                setUserNameValid(false);
            }else{
                checkUsernameToggle(true);
                setUserNameValid(true);
            }
        }
        initialRender.current["userNameReady"] = true;
    },[userName, trigger]);

    // checking email is in correct format
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    useEffect(() => {
        setEmailError("");
        if(initialRender.current["emailReady"]){
            if(email === ""){
                setEmailError("Please enter an email");
                checkEmailToggle(false);
                setEmailValid(false);
            }else if(!emailRegex.test(email)){
                setEmailError("Please check email format");
                checkEmailToggle(false);
                setEmailValid(false);
            }else{
                checkEmailToggle(true);
                setEmailValid(true);
            }
        }
        initialRender.current["emailReady"] = true;
    },[email, trigger]);

    const currentDate = new Date();
    useEffect(() => {
        const date = new Date(dob);
        setDobError("");
        if(initialRender.current["dobReady"]){
            if(dob === ""){
                setDobError("Please enter you Date of Birth");
                checkDobToggle(false);
                setDobValid(false);
            }
            else if(currentDate < date){
                setDobError("Invalid Date of Birth");
                checkDobToggle(false);
                setDobValid(false);
            }
            else{
                checkDobToggle(true);
                setDobValid(true);
            }
        }
        initialRender.current["dobReady"] = true;
    },[dob, trigger])

    // Checking password matches at least 8 characters long and contains at least one capital
    const passwordRegex = /^(?=.*[A-Z])[a-zA-Z\d]{8,}$/;
    useEffect(() => {
        setPasswordError("");
        if(initialRender.current["passwordReady"]){
            if(password === ""){
                setPasswordError("Please enter a password");
                checkPasswordToggle(false);
                setPasswordValid(false);
            }else if(!passwordRegex.test(password)){
                setPasswordError("Please Check password format");
                checkPasswordToggle(false);
                setPasswordValid(false);
            }else{
                checkPasswordToggle(true);
                setPasswordValid(true);
            }
        }
        initialRender.current["passwordReady"] = true;
    },[password, trigger]);

    // makes sures user types in the correct password
    useEffect(() => {
        setPasswordVerifyError("");
        if(initialRender.current["passwordVerifyReady"]){
            if(passwordVerify === ""){
                setPasswordVerifyError("Please verify password");
                checkPasswordVerifyToggle(false);
                setPasswordVerifyValid(false);
            }else{
                if(password != passwordVerify){
                    setPasswordVerifyError("Password does not match");
                    checkPasswordVerifyToggle(false);
                    setPasswordVerifyValid(false);
                }else{
                    checkPasswordVerifyToggle(true);
                    setPasswordVerifyValid(true);
                }
            }
        }
        initialRender.current["passwordVerifyReady"] = true;
    },[passwordVerify, trigger]);


    const fullNameRef = useRef(null);
    const userNameRef = useRef(null);
    const emailRef = useRef(null);
    const dobRef = useRef(null);
    const passwordRef = useRef(null);
    const passwrodVerifyRef = useRef(null);
    const submitButtonRef = useRef(null);

    // handling hitting enter
    useEffect(() => {
        const handleEnterKey = (event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            submitButtonRef.current?.click();
          }
        };
    
        if(fullNameRef.current){
            fullNameRef.current.addEventListener("keydown", handleEnterKey);
        }
        if(userNameRef.current){
            userNameRef.current.addEventListener("keydown", handleEnterKey);
        }
        if (emailRef.current) {
          emailRef.current.addEventListener("keydown", handleEnterKey);
        }
        if(dobRef.current){
            dobRef.current.addEventListener("keydown", handleEnterKey);
        }
        if (passwordRef.current) {
          passwordRef.current.addEventListener("keydown", handleEnterKey);
        }
        if(passwrodVerifyRef.current){
            passwrodVerifyRef.current.addEventListener("keydown", handleEnterKey);
        }
    
        return () => {
            if(fullNameRef.current){
                fullNameRef.current.removeEventListener("keydown", handleEnterKey);
            }
            if(userNameRef.current){
                userNameRef.current.removeEventListener("keydown", handleEnterKey);
            }
            if (emailRef.current) {
                emailRef.current.removeEventListener("keydown", handleEnterKey);
            }
            if(dobRef.current){
                dobRef.current.removeEventListener("keydown", handleEnterKey)
            }
            if (passwordRef.current) {
                passwordRef.current.removeEventListener("keydown", handleEnterKey);
            }
            if(passwrodVerifyRef.current){
                passwrodVerifyRef.current.removeEventListener("keydown", handleEnterKey);
            }
        };
      }, []); 



    //submit form
    const onSubmit = () => {
        if(!fullNameValid || !userNameValid || !emailValid || !dobValid || !passwordValid || !passwordVerifyValid){
            setTrigger(!trigger);
            return;
        }

        // puts loading message
        toaster.loading({
            title: "Regerstering Account and sending verification email",
            description: "Please wait...",
            type: "loading",
            duration: "5000",
        });
    
        const url = new URL('/api/enroll/putUserRegistration', window.location.origin);
    
        // trying to send verification email
        fetch(url, {
          method: 'POST',
          headers: { 
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            email: email.toLowerCase()
          })
        })
        .then(response => {
            if (!response.ok){
                if (response.status == 400){
                    throw new Error ("Email is required")
                }
                else if (response.status == 410){
                    throw new Error ("User with this email already exists")
                }
                else if (response.status == 500){
                    throw new Error ("Failed to send email please try again")
                }else if(response.status == 403){
                    throw new Error ("IP bloced due to excesive requests");
                }else if(response.status == 429){
                    throw new Error ("Too many request please wait a few minutes before trying again");
                }
                else {
                    throw new Error ("Error sending verification email");
                }
            }

            return response.json();
        })
        .then(data => {
            toaster.remove();
            console.log(`returned good status ${data.status}`)
            toaster.create({
                title: "Success verification Email sent",
                description: "Please go verify email and return to login",
                type: 'success',
            })
            setEmailSent(true);
        })
        .catch(error => {
            toaster.remove();
            setMessage(error.message);
            toaster.create({
                title: "Error",
                description: `${error.message}`,
                type: "error",
            })
            setEmailSent(true);
        });
    };

    // TODO if wanting auto login
    // this was an attempt for me to auto login after verification
    /*
    useEffect(() => {
        // check if user email is verified
        const url = new URL('/api/enroll/postCheckUserVerification', window.location.origin);
        
        // trying to chek if email is verified
        fetch(url, {
            method: 'POST',
            headers: { 
            'Accept': 'application/json',
            'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: email.toLowerCase()
            })
        })
        .then(response => {
            if (!response.ok){
                if (response.status == 400){
                    throw new Error ("Email is required")
                }
                else if(response.status == 401){
                    throw new Error ("User is not verified")
                }
                else {
                    throw new Error ("Error checking email verification");
                }
            }
            return response.json();
        })
        .then(data => {
            setEmailVerified(true);
        })
        .catch(error => {
            setMessage(error.message);
            setEmailVerified(false);
        });
    })
    */

    // calls creteUser once email is sent
    useEffect(() => {
        if(emailSent){
            createUser()
        }
    },[emailSent]);



    // Puts the user in the users db adds the password and displayname
    async function createUser(){

          const urlUsername = new URL('/api/enroll/postSetUserInfo', window.location.origin);
      
          fetch(urlUsername, {
            method: 'POST',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              fullName: fullName,
              username: userName,
              email: email.toLowerCase(),
              dob: dob,
              password: password,
            })
          })
          .then(response => {
              if (!response.ok){
                  if (response.status == 400){
                      throw new Error ("UserName must be non-empty and less than 35 characters")
                  }
                  else if(response.status == 401){
                    throw new Error ("Password must match the requirements");
                  }
                  else if(response.status == 403){
                    throw new Error ("User with this email already Exists")
                  }
                  else {
                      throw new Error ("Error setting username");
                  }
              }
  
              return response.json();
          })
          .then(data => {
              setTimeout(navToLogin, 5000);
          })
          .catch(error => {
              setMessage(error.message);
              toaster.create({
                  title: "Error",
                  description: `${error.message}`,
                  type: "error",
              })
          });
    }

    // TODO : This is not currently working
    // once the the user is created it logs them in
    /*
    useEffect (() => {
        if(usernameCreated && passwordCreated){
            const url = new URL('/api/auth/loginVerify', window.location.origin);

            fetch(url, {
            method: 'POST',
            headers: { 
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: email.toLowerCase(),
                password: password
            })
            })
            .then(response => response.json())
            .then(data => {
            if (data.token) {
                console.log("trying to login")
                if (data.token) {
                    localStorage.setItem('sessionToken', data.token);
                    navToDashboard();
                  } else {
                    setPasswordError("Invalid email or password");
                  }
            } else {
                setPasswordError("Invalid email or password");
            }
            })
            .catch(error => {
            setPasswordError("Invalid email or password");
            console.log(error)
            toaster.create({
                title: "Error",
                description: "Invalid email or password",
                type: "error",
            })
            });
        }
    }, [usernameCreated, passwordCreated])
    */


  return (
    <Box bg={"gray.100"} minH={"100vh"} p={6} w={'100vw'} alignContent={"center"}>
        <Center>
            <HStack w={'7/12'} h={'4/5'} style={{backgroundColor: "#011936"}}
             rounded={"4xl"} gap={0} p={0} shadow={"xl"}>
                <Box style={{backgroundColor: "#011936"}} w={'4/5'} rounded={"4xl"} paddingBottom={4} h={'full'}>
                    <Heading as={"h1"} align={"center"} fontSize={28} p={8} fontFamily={"Esteban"}>
                        Create Account
                    </Heading>
                    <HStack gap={8} paddingRight={8} paddingLeft={8} h={'full'} w={'full'} align={'flex-start'}>
                        <VStack gap={4} align={"flex-start"} h={'full'}>
                            <Field required label="Full Name" invalid={!checkFullName} errorText={fullNameError}>
                                <InputGroup w={"full"}>
                                    <Input placeholder={'Full Name'} bg={'gray.100'} rounded={'xl'} ref={fullNameRef}
                                        p={4} color={'black'} fontSize={20} onChange={ev => setFullName(ev.target.value)}>
                                    </Input>
                                </InputGroup>
                            </Field>
                            <Field required label="Date of Birth" invalid={!checkDob} errorText={dobError}>
                                <InputGroup color={'black'} w={'full'}>
                                    <Input placeholder={'Date of Birth'} bg={'gray.100'} rounded={'xl'} ref={dobRef} type='date'
                                        p={4} color={'black'} fontSize={20} onChange={ev => setDob(ev.target.value)}>
                                    </Input>
                                </InputGroup>
                            </Field>
                            <Field required label="Username" invalid={!checkUsername} errorText={userNameError}>
                                <InputGroup startElement={<FaRegUser />} w={"full"}>
                                    <Input placeholder={"Username"} bg={"gray.100"} rounded={"xl"} ref={userNameRef}
                                        p={4} color={"black"} fontSize={20} onChange={ev => setUserName(ev.target.value)}>            
                                    </Input>
                                </InputGroup>
                            </Field>
                            <Field required label="Email" invalid={!checkEmail} errorText={emailError}>
                                <InputGroup startElement={<MdOutlineMail />} w={"full"}>
                                    <Input placeholder={"Email"} bg={"gray.100"} rounded={"xl"} ref={emailRef} type='email'
                                        p={4} color={"black"} fontSize={20} onChange={ev => setEmail(ev.target.value)}>   
                                    </Input>
                                </InputGroup>
                            </Field>
                            <Link to={'/'}>
                                <Text _hover={{color: "#f9DC5C"}}>
                                    &#8592;Back
                                </Text>
                            </Link>
                        </VStack>
                        <VStack gap={2} align={"flex-start"} minH={'full'}>
                            <Field required label="Password" invalid={!checkPassword} errorText={passwordError} paddingBottom={3}>
                                <Text fontSize={12} color={"gray.200"} paddingTop={3} paddingBottom={2}>
                                    •Password must be minimum 8 characters
                                </Text>
                                <Text fontSize={12} color={"gray.200"} paddingBottom={3}>
                                    •Password must contain a capital letter
                                </Text>
                                <InputGroup startElement={<MdOutlineLock />} w={'full'}>
                                    <PasswordInput placeholder={"Password"} bg={"gray.100"} rounded={"xl"} ref={passwordRef}
                                        p={4} color={"black"} fontSize={20} onChange={ev => setPassword(ev.target.value)}>  
                                    </PasswordInput>
                                </InputGroup>
                            </Field>
                            <Field required label="Password verify" invalid={!checkPasswordVerify} errorText={passwordVerifyError}paddingBottom={4}>
                                <InputGroup startElement={<MdOutlineLock />} w={'full'}>
                                    <PasswordInput placeholder={"Re-Enter Password"} bg={"gray.100"} rounded={"xl"} ref={passwrodVerifyRef}
                                        p={4} color={"black"} fontSize={20} onChange={ev => setPasswordVerify(ev.target.value)}>    
                                    </PasswordInput>
                                </InputGroup>
                            </Field>   
                            <Button rounded={"xl"} style={{ backgroundColor: "#f9DC5C"}} fontFamily={"Esteban"} fontSize={20}
                            onClick={onSubmit} color={'black'} ref={submitButtonRef} w={'full'} marginTop={4}>
                                Create Account
                            </Button>
                        </VStack>
                    </HStack>
                    <Toaster />
                </Box>
                <Box style={{backgroundColor: "#B1BFFF"}} rounded={"4xl"} h={"calc(100vh*.9)"} w={'2/6'} alignContent={"center"}>
                    <Image src={logo} />
                </Box>
            </HStack>
        </Center>
    </Box>
  )
}

export default CreateAccount